// PasswordRules.tsx
import React from "react";

export interface PasswordRuleStatus {
  length: boolean;
  lowercase: boolean;
  uppercase: boolean;
  digit: boolean;
  special: boolean;
}

/** All Cognito-approved special characters *plus* internal space. */
const SPECIAL_CHAR_REGEX =
  /[ \^$*.\[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/;

/** Returns an object whose keys map 1-to-1 to your check-list. */
export const getPasswordRuleStatus = (
  value: string
): PasswordRuleStatus => ({
  length: value.length >= 8,
  lowercase: /[a-z]/.test(value),
  uppercase: /[A-Z]/.test(value),
  digit: /\d/.test(value),
  // interior space counts as special, but leading/trailing don’t
  special:
    SPECIAL_CHAR_REGEX.test(value) ||
    /\s/.test(value.slice(1, -1)),
});

// Password validation in single line
// const passwordValidator = (value) =>
//   /^(?=.{8,}$)(?!\s)(?!.*\s$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\s\^$*.\[\]{}()?\-"!@#%&/\\,><':;|_~`+=]).*$/.test(value);
export const passwordValidator = (value: string): boolean =>
  Object.values(getPasswordRuleStatus(value)).every(Boolean);

type Props = { password: string };

const ruleLabels: Record<keyof PasswordRuleStatus, string> = {
  length: "Contains at least 8 characters",
  lowercase: "Contains at least 1 lowercase letter",
  uppercase: "Contains at least 1 uppercase letter",
  digit: "Contains at least 1 number",
  special: "Contains at least 1 special character",
};

export const PasswordRules: React.FC<Props> = ({ password }) => {
  const status = getPasswordRuleStatus(password);

  return (
    <ul style={{ listStyle: "none", padding: 0 }}>
      {(Object.keys(status) as (keyof PasswordRuleStatus)[]).map(
        (key) => (
          <li
            key={key}
            style={{ color: status[key] ? "green" : "gray" }}
          >
            {ruleLabels[key]}
          </li>
        )
      )}
    </ul>
  );
};

